module.exports = {
          srcSet: __webpack_public_path__ + "f4a1ab3b4d46b6c9a62edad7881520e5-187.png"+" 187w",
          images:[ {path: __webpack_public_path__ + "f4a1ab3b4d46b6c9a62edad7881520e5-187.png",width: 187,height: 31}],
          src: __webpack_public_path__ + "f4a1ab3b4d46b6c9a62edad7881520e5-187.png",
          toString:function(){return __webpack_public_path__ + "f4a1ab3b4d46b6c9a62edad7881520e5-187.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAVklEQVR4nGN46al163Wk9f/XUTZ/X4dZ/HsdZvn/daTN/zexDv9eBZv+fZsT9P99fcZlhpcemudBEhCF5v9fBZn+B2l8E+/075W/wd83ye7/P7QWHAEA46gxpVrZzrEAAAAASUVORK5CYII=",
          width: 187,
          height: 31
        }